/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {yupResolver} from '@hookform/resolvers/yup'
import React, {FC, useEffect, useMemo, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useAuth} from '../../../../../../hooks/useAuth'
import {ExportDataModel} from '../../../../model'
import {getTableData, getModules, getTablesByModule, getProfileByUser} from '../../../../services'
import {Select} from '../../../../../../components/UI/Select'
import {FormProvider, useForm} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {ModalExportData} from '../Modal/ModalExportData'
import {schemaExportData} from '../../../../../../util/validation'
import {ExistPropertyName} from '../../../../../../util/functions'
const TableExportData: FC = () => {
  const {data, setData, loading, setLoading, clearSelected, selected} = useKTable()
  const {isAllowed} = useCentral()
  const {user} = useAuth()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [module, setModule] = useState<any>([])
  const [tableByModule, setTableByModule] = useState<any>([])
  const [formData, setFormData] = useState<any>({})
  const methods = useForm<ExportDataModel>({
    resolver: yupResolver(schemaExportData),
  })

  const {
    control,
    formState: {errors},
    setValue,
    handleSubmit,
    setError,
    reset,
    watch,
  } = methods

  const validateIsValues = (data: any[]) => {
    let isCompany =
      ExistPropertyName(data, 'columna', 'companiaId') ||
      ExistPropertyName(data, 'columna', 'CompaniaId')
    let isClient =
      ExistPropertyName(data, 'columna', 'clienteId') ||
      ExistPropertyName(data, 'columna', 'ClienteId')
    let isSite =
      ExistPropertyName(data, 'columna', 'siteId') || ExistPropertyName(data, 'columna', 'SiteId')
    setFormData({
      company: isCompany,
      client: isClient,
      site: isSite,
    })
  }

  const getTableDataList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getTableData({
        nombreTabla: watch('nombreTabla'),
        nombreAplicacion: watch('nombreAplicacion'),
      })
      if (!response.error) {
        setData(response.data)
        validateIsValues(response.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getModuleList = async () => {
    try {
      const response = await getModules({}, 1)
      const responseProfile = await getProfileByUser({usuarioId: user.id}, 1, 100)
      const dataProfile = responseProfile.data.data
      const filterPerfil = dataProfile.filter((item: any) => item.perfil === 'EXPORTACIÓN DE DATOS')
      let data = response.data.data
      let getModulesFilterByProfile = data.filter((valor) =>
        filterPerfil.some((elemento) => elemento.aplicacion === valor.nombre),
      )
      const mappedSites = getModulesFilterByProfile.map((item: any) => ({
        value: item.nombre,
        label: item.nombre,
      }))
      setModule(mappedSites)
    } catch (error) {}
  }
  const getTableByModuleList = async (name: string = '') => {
    try {
      const response = await getTablesByModule({nombreAplicacion: name}, 1)
      let data = response.data.data
      const mappedSites = data.map((item: any, index) => ({value: item.Tabla, label: item.Tabla}))
      setTableByModule(mappedSites)
    } catch (error) {}
  }
  useEffect(() => {
    getModuleList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns: Column<ExportDataModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
        accessor: 'modulo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tabla' />,
        accessor: 'tabla',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Columna' />,
        accessor: 'columna',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de dato' />,
        accessor: 'tipoDeDato',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Longitud' />,
        accessor: 'longitud',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].columna} />,
      },
    ],
    [],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  const handleFilterTable = (e: any) => {
    const {value, label} = e
    setTableByModule([])
    setValue('nombreTabla', '')
    setError('nombreTabla', {})
    getTableByModuleList(label)
    setValue('nombreAplicacion', value)
    setError('nombreAplicacion', {})
  }
  const handleResetForm = () => {
    reset()
    setData([])
    clearSelected()
    setFormData({})
  }
  const onSubmit = (data: ExportDataModel) => {
    clearSelected()
    setData([])
    setFormData({})
    getTableDataList()
  }
  const handleExport = () => {
    let textConcat = ''
    selected.forEach((item: any) => {
      if (textConcat) {
        textConcat = textConcat + ',' + item
      } else if (textConcat === '') {
        textConcat = item
      }
    })
    let obj = {
      ...formData,
      aplicacion: watch('nombreAplicacion'),
      tabla: watch('nombreTabla'),
      campos: textConcat,
    }
    setFormData(obj)
    setShowModal(true)
  }
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          {isAllowed('BUSCAR_ENCABEZADO') && (
            <div className='p-6'>
              <FormProvider {...methods}>
                <form className='m-2'>
                  <div className='row'>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Módulo:</label>
                      <Select
                        control={control}
                        name='nombreAplicacion'
                        data={module}
                        errors={errors}
                        onChangeValue={handleFilterTable}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Tabla:</label>
                      <Select
                        control={control}
                        name='nombreTabla'
                        data={tableByModule}
                        disabled={tableByModule.length === 0}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-start'>
                    <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                    <Button label='Limpiar' onClick={() => handleResetForm()} />
                    {isAllowed('EXPORTAR') && (
                      <Button
                        label='Exportar'
                        onClick={handleExport}
                        disabled={selected.length === 0}
                      />
                    )}
                  </ButtonWrapper>
                </form>
              </FormProvider>
            </div>
          )}
          <div>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          </div>

          <ModalExportData
            show={showModal}
            setShow={setShowModal}
            dataValidate={formData}
            columns={selected}
          />
        </KTCard>
      )}
    </>
  )
}

const TableExportDataWrapper = () => {
  return (
    <KTableProvider>
      <TableExportData />
    </KTableProvider>
  )
}

export {TableExportDataWrapper}
